<div class = "title-container">
    {{messages[step]}}
</div>
<div class="insights-container">
    <div class="summary-container">
        @if (step === 0) {
            <app-insights-overview [summary]="true" [linqset]="linqset"></app-insights-overview>
        }
        @if (step === 1) {
            <app-basic-node-table [includeCarbon]="true" [typeData]="typeData" [field]="fieldType.type" [linqset]="linqset"></app-basic-node-table>
        }
        @if (step === 2) {
            <app-node-bar-chart [linqset]="linqset" [typeData]="typeData" [fieldType]="fieldType" [width]="800" [height]="450"></app-node-bar-chart>
        }
    </div>
</div>